import React, { Component } from 'react';
import AutoBind from 'react-autobind';

import TableSucursal from './children/tabla-sucursal';
import TableCadena from './children/tabla-cadena';
import TableAutorizador from './children/tabla-autorizador';
import TableGeneral from './children/tabla-general';

import { 
    Sucursal_Lista, ParametroSucursal_Listkey, ParametroSucursal_GuardarCFDI, ParametroCadena_Listkey, ParametroCadena_GuardarCFDI, SAT_RegimenFiscal_Lista, SAT_RegimenFiscal_ListaALL,
    ParametroCadena_GuardarCFDI_Logo, Empresa_lista, Cadena_lista, Parametros_General_ListKey, Autorizador_Factura_Insert,
    Autorizador_Factura_ListKey, Fiscal_Tipo_Global_List, Fiscal_Tipo_Global_ListKey, Sucursal_fiscal_Insert, Sucursal_Fiscal_ListKey, Autorizador_Factura_List
} from '../../request/rfc';



const DefaultOptionSucursal = { Suc_Id: 0, Nombre: 'Seleccione Sucursal >>' };
const DefaultOptionRegimenFiscal = { Regimen_Clave: 0, Regimen_Clave: 'Seleccione un Regimen Fiscal >>' };
const DefaultOptionEmpresa = { Id: 0, Nombre: 'Seleccionar Empresa' }
const DefaultOptionCadena = { Id: 0, Nombre: 'Seleccionar Cadena' }
const DefaultOptionTipoFactura = { Id: 0, Nombre: 'Seleccionar Tipo Factura' }
const DefaultOptionAutorizador = { Id: 0, Nombre: 'Seleccionar Autorizador' }
export default class Parametro extends Component {


    constructor(props) {
        super(props);
        this.state = {
            checkedTab: 'general',
            sucursales: [],
            sucursal: {},
            cadena: {},
            versiones: [],
            regimenFiscales: [],
            selectedFile: '',
            autorizador:[],
            general: [],
            siteInterno: [],
            empresas: [],
            cadenas: [],
            empresa: {},
            cadena: {},
            globalDescription :'',
            globalOptions: [],
            globalSelect: '',
            sucursalF: {},
            autorizadores: [],
            Cancelacionversiones: [],
        };
        AutoBind(this);
    }

    componentDidMount() {

        Sucursal_Lista()
        .then(({ data: Response }) => {
            const { Message, Data: sucursales } = Response;
          
            if(Message !== '') {
                alert(Message);
            } else {
                this.setState({ sucursales: [DefaultOptionSucursal, ...sucursales] });
            }
        })
        .catch((err) => { console.log(err); });

        Empresa_lista()
            .then(({ data: Response }) => {

                const { Message, Data: empresasList } = Response;
                if (Message !== '') {
                    alert(Message)
                } else {
                    this.setState({ empresas: [DefaultOptionEmpresa, ...empresasList.Table] })
                }                
            })
            .catch((err) => { console.log(err); })

        Cadena_lista()
            .then(({ data: Response }) => {
                const { Message, Data: cadenasList } = Response;       
                if (Message !== '') {
                    alert(Message)
                }
                else {
                    this.setState({ cadenas: [DefaultOptionCadena, ...cadenasList.Table] })
                }

                
            })
            .catch((err) => { console.log(err) })
        Autorizador_Factura_List()
            .then(({ data: Response }) => {
                const { Message, Data: autorizador } = Response;
                if (Message !== '') {
                    alert(Message)
                }
                else {
                    this.setState({ autorizadores: [DefaultOptionAutorizador, ...autorizador.Table] })
                }
            })
            .catch((err) => { console.log(err) })
        Parametros_General_ListKey()
            .then(({ data: Response }) => {
                const { Message, Data: datos } = Response;
                if (Message != '') {
                    alert(Message)
                }
                else {
                    this.setState({ general: datos })
                }
            })
            .catch((err) => { console.log(err) })
        Autorizador_Factura_ListKey(0)
            .then(({ data: Response }) => {
                DefaultOptionAutorizador
                const { Message, Data: datos } = Response;
                if (Message != '') {
                    alert(Message)
                }
                else {
                    this.setState({ autorizador: datos })
                }
            })
            .catch((err) => { console.log(err) })
        Fiscal_Tipo_Global_List()
            .then(({ data: Response }) => {
                const { Message, Data: datos } = Response;
                if (Message != '') {
                    alert(Message)
                }
                else {
                    this.setState({ globalOptions: [DefaultOptionTipoFactura, ...datos.Table] })
                }
            })
            .catch((err) => { console.log(err) })

        Sucursal_Fiscal_ListKey(0)
            .then(({ data: Response }) => {
                const { Message, Data: datos } = Response;
                if (Message != '') {
                    alert(Message)
                }
                else {
                    this.setState({ sucursalF: datos })
                }
            })
            .catch((err) => { console.log(err) })
        this.cargarParamsCadena();

        this.setState({ versiones: ['3.3', '4.0'] });
        this.setState({ Cancelacionversiones: ['1.0', '2.0'] });

        this.setState({ siteInterno: ['SI', 'NO'] });

        SAT_RegimenFiscal_ListaALL()
            .then(({ data: Response }) => {
                const { Message, Data: regimenFiscales } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ regimenFiscales: [DefaultOptionRegimenFiscal, ...regimenFiscales] });
                }
            })
            .catch((err) => { console.log(err); });
    }

    onChangeTab(e) {
        const { value: checkedTab } = e.target;
        this.setState({ checkedTab });
    }

    onChange(e) {
        const { name, value, text } = e.target;
        if (name === 'sucursal') {

            this.setState({             
               sucursalF: { ...this.state.sucursalF, Suc_id: value }
            });

            this.cargarParamsSucursal(value);
        } else if (name === 'Cadena_CFDI_Version') {
            console.log(name)
            this.setState({
                cadena: Object.assign({}, this.state.cadena, { [name]: value }),
                hasChanges: name === 'versiones' ? false : true // no valida el cambio si es RFC ya que tiene que digitarlo para buscar
            });
        } else if (name === 'Cadena_Regimen_Codigo') {

            this.setState({
                cadena: Object.assign({}, this.state.cadena, { [name]: value }),
                hasChanges: name === 'versiones' ? false : true // no valida el cambio si es RFC ya que tiene que digitarlo para buscar
            });
        } else if (name === 'empresa') {
            console.log(name)
            this.setState({
                general: Object.assign({}, this.state.general, { [name]: value })
            });
           
        }
        else if (name ==='tipofacturaglobal'){
            this.cargarDescriptionGlobal(value);
        }
        else if (name ==='Autorizador'){
            console.log(name)
            this.setState({
                autorizador: {
                    ...this.state.autorizador, Autorizador_Id: value,
                }
            });

            this.cargarDatosAutorizador(value);
        } else if (name === 'Cadena_Leyenda_Web') {
             console.log(name)
             this.setState({
                 cadena: Object.assign({}, this.state.cadena, { [name]: value }),
             });
        } else if (name === 'Cadena_CFDI_Cancelcion_Version') {
            console.log(name)
            this.setState({
                cadena: Object.assign({}, this.state.cadena, { [name]: value }),
            });
        }else {
            this.cargarParamsCadena(value);
        }
    }
    

    onChangeInputTableSucursal(e) {
        const { name, value } = e.target;
        const sucursalF = Object.assign({}, this.state.sucursalF, { [name]: value });        
        this.setState({ sucursalF });
    }

    onChangeInputTableCadena(e) {
        const { name, value } = e.target;
        const cadena = Object.assign({}, this.state.cadena, {[name]: value});
        this.setState({ cadena });
    }

    onChangeInputTableImagen(e) {

        this.setState({ selectedFile: e.target.files[0] })
    }
    onChangeInputUploadFile() {

        const formData = new FormData();
        formData.append("pFile", this.state.selectedFile)
        console.log('datos de select', this.state.selectedFile);
        console.log('el formData', formData)
        var config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        ParametroCadena_GuardarCFDI_Logo(formData, config)
            .then(({ data: Response }) => {
                const { Message } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    alert('La imagen se guardo correctamente');
                }

            })
    }
    
    onChangeInputTableGeneral(e) {
        const { name, value } = e.target;
        const general = Object.assign({}, this.state.general, { [name]: value });
        this.setState({ general});
     
    }

    onChangeInputTableAutorizador(e) {
        const { name, value } = e.target;
        const autorizador = Object.assign({}, this.state.autorizador, { [name]: value });
        this.setState({ autorizador });
    }

    cargarParamsSucursal(sucursal) {
        Sucursal_Fiscal_ListKey(sucursal)
            .then(({ data: Response }) => {
                const { Message, Data: datos } = Response;
                if (Message != '') {
                    alert(Message)
                }
                else {
                    this.setState({ sucursalF: datos })
                }
            })
            .catch((err) => { console.log(err) })
    }

    cargarParamsCadena() {
        ParametroCadena_Listkey()
        .then(({ data: Response }) => {
            const { Message, Data: cadena } = Response;
            if(Message !== '') {
                alert(Message);
            } else {
                this.setState({ cadena });
            }
        })
        .catch((err) => { console.log(err); });
    }

    cargarDescriptionGlobal(global_Id)
    {
        if (global_Id === '0') {
            return;
        }
        Fiscal_Tipo_Global_ListKey(global_Id)
            .then(({ data: Response}) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({
                        sucursalF: { ...this.state.sucursalF, Fiscal_Tipo_Global_id: global_Id }
                    });
                    this.setState({ globalDescription: Data.Descripcion })
                   // this.setState({ globalSelect: global_Id })
                    
                }
            })
    }
    cargarDatosAutorizador(pAutorizador_Id) {

        Autorizador_Factura_ListKey(pAutorizador_Id)
            .then(({ data: Response }) => {
                const { Message, Data } = Response
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({
                        autorizador: Object.assign({}, this.state.autorizador, { ...Data })
                    })
                }
            })
            .catch((err) => { console.log(err); });
    }
    onSaveFiscalSucursal() {
       
        console.log('la Sucursal', this.state.sucursalF)
        Sucursal_fiscal_Insert(this.state.sucursalF)
            .then(({ data: Response }) => {
                const { Message } = Response;
                if(Message !== '') {
                    alert(Message);
                } else {
                    alert('Datos almacenados correctamente');
                }
            })
            .catch((err) => { console.log(err); });
    }
    
    onSaveParamsCadena() {
        ParametroCadena_GuardarCFDI(this.state.cadena)
        .then(({ data: Response }) => {
            const { Message } = Response;
            if(Message !== '') {
                alert(Message);
            } else {
                this.onChangeInputUploadFile();
                alert('Datos almacenados correctamente');
            }
        })
        .catch((err) => { console.log(err); });
    }

    onSaveParamsGeneral() {
        Parametros_Generales_Save(this.state.general)
            .then(({ data: Response }) => {
                const { Message } = Response;
                if (Message !== '') {
                    alert(Message);
                }
                else {
                    alert('Los datos se guardaron correctamente');
                }
            })
    }

    onSaveParamsAutorizador() {
       

        Autorizador_Factura_Insert(this.state.autorizador)
            .then(({ data: Response }) => {
                const { Message } = Response;

                if (Message !== '') {
                    alert(Message);
                }
                else {
                    alert('Los datos se guardaron correctamente');
                }
            })
            .catch((err) => { console.log(err); });
    }

   
    render() {

        const { checkedTab, sucursales, sucursal, sucursalF, cadenas, cadena, empresas, versiones, regimenFiscales, autorizador, general, globalDescription, globalOptions, autorizadores, Cancelacionversiones } = this.state;
        
        return (
            <div className="tabs">
                <input type="radio" id="tabGeneral" name="tab-control" value="general" checked={checkedTab === 'general'} onChange={this.onChangeTab} />
                <input type="radio" id="tabSucursal" name="tab-control" value="sucursal" checked={checkedTab === 'sucursal'} onChange={this.onChangeTab} />
                <input type="radio" id="tabCadena" name="tab-control" value="cadena" checked={checkedTab === 'cadena'} onChange={this.onChangeTab} />
                <input type="radio" id="tabAutorizador" name="tab-control" value="autorizador" checked={checkedTab === 'autorizador'} onChange={this.onChangeTab} />
                <ul>
                    <li title="General"><label htmlFor="tabGeneral" role="button"><span>General</span></label></li>
                    <li title="Sucursal"><label htmlFor="tabSucursal" role="button"><span>Sucursal</span></label></li>
                    <li title="Cadena"><label htmlFor="tabCadena" role="button"><span>Cadena</span></label></li>
                    <li title="Autorizador"><label htmlFor="tabAutorizador" role="button"><span>Autorizador</span></label></li>
                </ul>
                <div className="slider"><div className="indicator"></div></div>
                <div className="content">
                    <section>
                        <h2>General</h2>
                        <TableGeneral general={general}
                            empresas={empresas}
                            cadenas={cadenas}
                            onChange={this.onChange}
                            onChangeInputTableGeneral={this.onChangeInputTableGeneral}
                            onSaveParamsGeneral={this.onSaveParamsGeneral}

                        />
                    </section>
                    <section>
                        <h2>Sucursal</h2>
                        <TableSucursal sucursalF={sucursalF}
                            sucursales={sucursales}
                            globalDescription={globalDescription}
                            globalOptions={globalOptions}
                            onChange={this.onChange}
                            onChangeInputTableSucursal={this.onChangeInputTableSucursal}
                            onSaveFiscalSucursal={this.onSaveFiscalSucursal}
                        />
                    </section>
                    <section>
                        <h2>Cadena</h2>
                        <TableCadena cadena={cadena}
                            versiones={versiones}
                            onChangeInputTableCadena={this.onChangeInputTableCadena}
                            onSaveParamsCadena={this.onSaveParamsCadena}
                            onChangeInputTableImagen={this.onChangeInputTableImagen}
                            onChange={this.onChange}
                            regimenFiscales={regimenFiscales}
                            Cancelacionversiones={Cancelacionversiones}
                        />                      
                    </section>
                    <section>
                        <h2>Autorizador</h2>
                        <TableAutorizador autorizador={autorizador}
                            autorizadores={autorizadores}
                            onChangeInputTableAutorizador={this.onChangeInputTableAutorizador}
                            onSaveParamsAutorizador={this.onSaveParamsAutorizador}
                            onChange= {this.onChange} />
                    </section>
                </div>
            </div>
           
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/parametro/index.jsx